import { Component, OnInit } from '@angular/core';
import { WorkflowTaskModel } from '../../model/common/workflowTask.model';
import {WorkflowTaskPermission, WorkflowTaskSummaryModel} from '../../model/common/workflowTaskSummary.model';
import { ItemSummaryPlainEntityOrSummaryComponent } from '../../../../../common/item/item-summary-plain-entity-or-summary/item-summary-plain-entity-or-summary.component';
import {DialogController} from '../../../../../common/dialog/dialogController';
import {
    WorkflowTaskHumanSaveDialogInput,
    WorkflowTaskHumanSavePage
} from '../../../impl/page/workflow-task-human-save/workflow-task-human-save.page';
import {TaskCommandService} from '../../command/taskCommand.service';
import {
    EmailSentViewComponent, EmailSentViewInput
} from "../../../../../communication/email/api/component/email-sent-view/email-sent-view.component";
import {WorkflowApplicationTaskExecuteService} from "../../../impl/service/workflowApplicationTaskExecute.service";
import {AuthService} from "../../../../../auth/api/service/auth.service";
import {
    WorkflowApplicationTaskExecutePayload
} from "../../../impl/service/payload/workflowApplicationTaskExecute.payload";

@Component({
    selector: 'app-workflow-task-item',
    templateUrl: './workflow-task-item.component.html',
    providers: [
        WorkflowApplicationTaskExecuteService
    ]
})
export class WorkflowTaskItemComponent extends ItemSummaryPlainEntityOrSummaryComponent<WorkflowTaskSummaryModel, WorkflowTaskModel>
    implements OnInit {

    constructor(private dialogController: DialogController,
                private taskCommandService: TaskCommandService,
                public executeService: WorkflowApplicationTaskExecuteService,
                public authService: AuthService) {
        super();
    }

    ngOnInit() {
    }

    edit() {
        const input: WorkflowTaskHumanSaveDialogInput = {
            id: this.summary.id
        };
        this.dialogController.open(WorkflowTaskHumanSavePage,
            input, {
                title: 'Modifier la tâche'
            });
    }

    buildExecutePayload = (): WorkflowApplicationTaskExecutePayload => {
        return {
            id: this.summary.id,
            allowExecutionIfDone: true,
            async: true
        };
    }

    view() {
        if (this.summary.workflowTaskDefinition?.name === 'communication.sendEmail') {
            this.dialogController.open(EmailSentViewComponent, {
                id: this.summary.id
            } as EmailSentViewInput, {
                title: 'E-mail envoyé'
            });
        } else {
            this.redirectToFromCommandAction(this.taskCommandService.viewTask(this.summary));
        }
    }

    protected readonly WorkflowTaskPermission = WorkflowTaskPermission;
}
